import keyMirror from 'keymirror'

export const ActionTypes = keyMirror({
  INIT: null,
  INIT_TILES: null,

  UPDATE_DATA: null,

  CHANGE_TIMEFRAME_STARTED: null,
  CHANGE_TIMEFRAME_COMPLETED: null,
  CHANGE_TIMEFRAME_FAILED: null,
})

export const PayloadSources = keyMirror({
  SERVER_ACTION: null,
  VIEW_ACTION: null,
})
